function Panama({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1879)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M0 16C0 24.8365 7.1635 32 16 32C16 25.9153 16 16 16 16C16 16 5.56519 16 0 16Z" fill="#0052B4"/>
  <path d="M16 0C24.8365 0 32 7.1635 32 16C25.9153 16 16 16 16 16C16 16 16 5.56519 16 0Z" fill="#D80027"/>
  <path d="M9.52437 5.56445L10.5604 8.75308H13.9131L11.2007 10.7237L12.2367 13.9123L9.52437 11.9416L6.81199 13.9123L7.84799 10.7237L5.13562 8.75308H8.4883L9.52437 5.56445Z" fill="#0052B4"/>
  <path d="M22.4757 18.0879L23.5117 21.2765H26.8644L24.152 23.2471L25.188 26.4358L22.4757 24.4651L19.7633 26.4358L20.7993 23.2471L18.0869 21.2765H21.4396L22.4757 18.0879Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Panama;
